import axiosInstance, { uninterceptedAxiosInstance } from "@/lib/axios";

import {
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  UserProfile,
} from "../types/LoginAuth";

export const loginAuthAPI = {
  login: async (request: LoginRequest): Promise<LoginResponse> => {
    const { device_id: deviceId, ...payload } = request;
    const response = await axiosInstance.post<LoginResponse>(
      "/users/token/",
      {
        ...payload,
        device_id: deviceId,
      },
      {
        headers: {
          "X-Client-Fingerprint": deviceId,
        },
      },
    );
    return response.data;
  },

  refreshToken: async (
    request: RefreshTokenRequest,
  ): Promise<RefreshTokenResponse> => {
    // Use unintercepted instance to avoid interceptor loops
    const response =
      await uninterceptedAxiosInstance.post<RefreshTokenResponse>(
        "/users/token/refresh/",
        request,
      );
    return response.data;
  },

  getProfile: async (): Promise<UserProfile> => {
    const response = await axiosInstance.get<UserProfile>("/users/profile/");
    return response.data;
  },

  logout: async (): Promise<LogoutResponse> => {
    const response = await axiosInstance.post<LogoutResponse>("/auth/logout/");
    return response.data;
  },
};
